import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Chip, Divider, Grid, Typography } from '@material-ui/core';
import React, { useEffect } from 'react';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CommentInput from '../components/CommentInput/CommentInput';
import { InputBox } from './InitialSetup/InitialSetupSection';
import { useLang } from '../../../util/lang';
import useDraftComment from '../hooks/useDraftComment';
import useRequestCommentCommon from '../hooks/useRequestCommentCommon';
import useAuth from '../../../hooks/useAuth';
import { withStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';

const StyledAccordionSummary = withStyles({
    root: {
        minHeight: 48,
        padding: "0px 12px",
        '&$expanded': { minHeight: 48, },
    },
    content: {
        margin: '4px 0',
        '&$expanded': { margin: '4px 0', },
    },
    expanded: {},
})(AccordionSummary);

const AccordionPlanReceived = ({
    plan,
    index,
    caseId,
    latest,
    handleCmBoxExpanded,
    handleCmBoxClick,
    cmBoxExpanded,
    isEditingComment = false,
    currentTreatmentPlan,
    handleApproveTreatmentPlanByCaseType,
    isEnablePlanApproval = false,
}) => {
    const get = useLang();
    const auth = useAuth();
    const history = useHistory();
    
    const currentUserRole = auth.user.role;
    const { draftCommentValue, isCommentUnsaved, getMessageLabel } = useDraftComment({
        currentPlanId: plan.plan_id,
        planComment: plan?.comment,
    });

    const { isCommentReadOnly, updatedByDisplay } = useRequestCommentCommon({ plan });

    const isThisPlanActive = currentTreatmentPlan?.plan_id?.toString() === plan?.plan_id?.toString();
    const isPlanApproved = !!plan.approved_flag;

    return (
        <Accordion
            key={`R${plan.refinement_no}I${index}`}
            expanded={cmBoxExpanded}
            style={{
                border: isThisPlanActive ? '2px solid rgb(44, 192, 234)' : '2px solid transparent',
                borderRadius: 4,
                boxShadow: isThisPlanActive ? '0px 1px 4px rgba(44, 192, 234, 0.04)' : '0px 1px 4px rgba(0, 0, 0, 0.1)',
                overflow: 'hidden',
            }}
        >
            <StyledAccordionSummary
                style={{ opacity: isThisPlanActive ? '1' : '0.6', }}
                expandIcon={
                    <ExpandMoreIcon
                        style={{ pointerEvents: 'auto', fontSize: 20, }}
                        onClick={(e) => {
                            e.stopPropagation();
                            handleCmBoxExpanded(plan.plan_id);
                        }}
                    />
                }
            >
                <Grid container spacing={0} alignItems="center" onClick={() => { handleCmBoxClick(plan.plan_id); }} style={{ ':hover': { background: 'red', }, }}>

                    {/* Treatment Plan Title */}
                    <Grid item xs={6} md={7}>
                        <Typography style={{ fontSize: 15 }}>
                            {index}. {get('@TreatmentPlanHistory.initialSetup')}{' '}
                            {plan?.plan_no ? `(TP${plan.plan_no}) ` : ''}
                            {plan?.refinement_no && plan.refinement_no !== 0 ? `(R${plan.refinement_no})` : ''}
                        </Typography>
                    </Grid>

                    {/* Approval Button */}
                    <Grid item xs={6} md={5}>
                        <Box style={{ display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
                            {isPlanApproved ? (
                                <Chip size="small" label={get('@PatientInfo.log.approved')} />
                            ) : (
                                ['DR'].includes(currentUserRole) &&
                                isEnablePlanApproval && (
                                    <Button
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            if (plan && plan?.plan_id) {
                                                if (
                                                    handleApproveTreatmentPlanByCaseType &&
                                                    typeof handleApproveTreatmentPlanByCaseType === 'function'
                                                ) {
                                                    handleApproveTreatmentPlanByCaseType(plan.plan_id);
                                                }
                                            }
                                        }}
                                        type="button"
                                        size="small"
                                        variant="contained"
                                        disabled={!isThisPlanActive}
                                        style={{
                                            background: isThisPlanActive ? '#39a8bd' : '#6c757d',
                                            color: '#fff',
                                            fontSize: '11px',
                                            fontWeight: 600,
                                            padding: '4px 16px',
                                            lineHeight: 1.2,
                                            borderRadius: '8px',
                                        }}
                                    >
                                        {get('@PatientInfo.clinicalSimulation.buttons.approveTreatmentPlan')}
                                    </Button>
                                )
                            )}
                        </Box>
                    </Grid>
                </Grid>
            </StyledAccordionSummary>

            <AccordionDetails style={{ borderTop: '1px solid #d6d6d691', opacity: isThisPlanActive ? '1' : '0.6', padding: '4px 16px 12px 16px', }} >
                <Grid container>
                    {/* Admin */}
                    <Grid item xs={12}>
                        <CommentInput
                            label={getMessageLabel(get('@TreatmentPlanHistory.designerComment'), isCommentUnsaved)}
                            defaultValue={draftCommentValue}
                            caseId={caseId}
                            planId={plan?.plan_id}
                            updatedDate={plan?.comment_updated_date}
                            readOnly={isCommentReadOnly}
                            isEditing={isEditingComment}
                            updatedBy={updatedByDisplay}
                            created_date={plan?.comment_created_date}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <Divider style={{ backgroundColor: '#d6d6d691', margin: '8px 0px' }} />
                    </Grid>

                    {/* Doctor */}
                    <Grid item xs={12}>
                        <InputBox label={get('@TreatmentPlanHistory.initialSpecial')} readOnly data={plan.request} updatedDate={plan?.request_updated_date} created_date={plan?.request_created_date}  />
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
};

export default AccordionPlanReceived;
